import { App } from './app';

export { App };
